{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPIGroup} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/searchfield';
import statelyDocs from 'docs:@react-stately/searchfield';
import Anatomy from '/packages/dev/s2-docs/pages/react-aria/SearchFieldAnatomy.svg';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a search field.';
export const isSubpage = true;

# useSearchField

<PageDescription>{docs.exports.useSearchField.description}</PageDescription>

```tsx render files={["starters/hooks/src/SearchField.tsx", "starters/hooks/src/SearchField.css", "starters/hooks/src/TextField.css", "starters/hooks/src/Form.css"]}
"use client";
import {SearchField} from 'hooks-starter/SearchField';

<SearchField label="Search" onSubmit={text => alert(text)} />
```

## API

<Anatomy />

```tsx
<SearchField>
  <Label />
  <Input />
  <Button />
  <Text slot="description" />
  <FieldError />
</SearchField>
```

<FunctionAPIGroup
  functions={[
    {function: statelyDocs.exports.useSearchFieldState, links: statelyDocs.links},
    {function: docs.exports.useSearchField, links: docs.links},
  ]}
/>

### SearchFieldState

<InterfaceType {...statelyDocs.exports.SearchFieldState} links={statelyDocs.links} />

### AriaSearchFieldProps

<InterfaceType {...docs.exports.AriaSearchFieldProps} />

### SearchFieldAria

<InterfaceType {...docs.exports.SearchFieldAria} />
